import _createForOfIteratorHelper from "/app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "/app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.push.js";
import { __decorate } from "tslib";
import { Options, Vue } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import Card from '@/components/layout/Card.vue';
var AuthItemAttributeTable = /*#__PURE__*/function (_Vue) {
  function AuthItemAttributeTable() {
    var _this;
    _classCallCheck(this, AuthItemAttributeTable);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, AuthItemAttributeTable, [].concat(args));
    _defineProperty(_this, "authItem", void 0);
    _defineProperty(_this, "errorMsg", '');
    return _this;
  }
  _inherits(AuthItemAttributeTable, _Vue);
  return _createClass(AuthItemAttributeTable, [{
    key: "authItemAttribueMapped",
    get: function get() {
      var listOfAttriibute = new Array();
      var _iterator = _createForOfIteratorHelper(this.authItem.authItemAttributes),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var attribute = _step.value;
          if (attribute.mapping.length > 0) {
            listOfAttriibute.push(attribute);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return listOfAttriibute;
    }
  }]);
}(Vue);
__decorate([Prop()], AuthItemAttributeTable.prototype, "authItem", void 0);
AuthItemAttributeTable = __decorate([Options({
  components: {
    Card: Card
  }
})], AuthItemAttributeTable);
export default AuthItemAttributeTable;